module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('admin-layout', [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v("Scoring Models Rules "), (_vm.is_admin) ? _c('button', {
    staticClass: "btn btn-custom",
    on: {
      "click": function($event) {
        return _vm.toggleFilterModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Rule")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.filtersList), function(r, ir) {
    return _c('div', {
      key: r.id,
      staticClass: "filter",
      class: {
        'filter-disabled': !r.active
      }
    }, [_c('div', {
      staticClass: "text-right filter-controls"
    }, [(_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": ir == 0
      },
      on: {
        "click": function($event) {
          return _vm.moveUpFilter(ir)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      attrs: {
        "disabled": (ir + 1) == _vm.filtersList.length
      },
      on: {
        "click": function($event) {
          return _vm.moveDownFilter(ir)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.toggleFilterModal(r)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.is_admin) ? _c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.deleteFilter(ir)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v("Priority: "), _c('b', [_vm._v(_vm._s(ir + 1))]), _vm._v(" (Rate: "), _c('b', [_vm._v(_vm._s(r.rate) + "%")]), _vm._v(")")]), _vm._v(" "), _c('h5', [_vm._v("Status: "), _c('b', [(r.active) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Inactive")])])]), _vm._v(" "), _c('h5', [_vm._v("Model: "), _c('b', [_vm._v(_vm._s(r.scoring_model.name))])]), _vm._v(" "), (r.test_scoring_models.length) ? _c('h5', [_vm._v("Test Models: "), _c('ul', {
      staticClass: "list-inline"
    }, _vm._l((r.test_scoring_models), function(tm) {
      return _c('li', [_vm._v(_vm._s(tm.name))])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rules"
    }, [_c('boolean-expression-widget', {
      attrs: {
        "expression": r.rule
      },
      on: {
        "updateExpression": function($event) {
          return _vm.updateExpression($event, r)
        }
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.is_admin) ? _c('button', {
    staticClass: "btn btn-custom",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveTable()
      }
    }
  }, [_vm._v("Save")]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.showFilterModal) ? _c('scoring-model-rule-modal', {
    attrs: {
      "filter": _vm.filter
    },
    on: {
      "close": function($event) {
        _vm.showFilterModal = false
      },
      "save": _vm.saveFilter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRuleModal) ? _c('rule-modal', {
    attrs: {
      "available-fields": _vm.fields,
      "condition": _vm.condition
    },
    on: {
      "close": function($event) {
        _vm.showRuleModal = false
      },
      "save": _vm.saveCondition
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6c6efb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/ScoringModelRulesSettings.vue
// module id = 681
// module chunks = 0